import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DataLoader from '../../../../../Utils/DataLoader';
import { subject_all, subject_destroy } from '../../../../apis/ClassManagment/Subject';
import CustomTable from '../../CustomTable.jsx';

export const columns = [
    {
        name: 'No.',
        selector: 'no',
        sortable: true,
    },
    {
        name: 'SUBJECT',
        selector: 'subject',
        sortable: true,
    },
    // {
    //     name: 'Delete',
    //     selector: 'action',
    //     sortable: true,
    // }
];

const AllSubjects = () => {
    const [data, setData] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const userData = JSON.parse(localStorage.getItem('userData'));
    useEffect(() => {
        async function get_data() {
            const result = await subject_all(userData?.data?.id);
            const arrayData = result?.data?.map((elem, index) => {
                const { id, subject } = elem;
                return {
                    no: `#${index + 1}`,
                    subject: subject,
                    // action: <><Link className='edit-btn' to={`/teacher/admin/subject/edit/${id}`}>Modify</Link><button className="dlt-btn" onClick={() => destroy(id)}> Delete</button></>
                };
            });
            setData(arrayData, setShowResults(true));
        }
        const destroy = (id) => {
            const result = window.confirm("Are you sure you want to delete?");
            if (result) {
                subject_destroy(id);
            }
            get_data();
        }
        get_data();
    }, []);

    return (
        <div className="right-nav" id="dash-event">
            <div className='row'>
                <div className='col-md-4'>
                    <h4 className='modal-title'>Subject List</h4>
                </div>
                <div className='col-md-8'>
                    {/* <Link className='ui button float-end' to="/teacher/admin/subject/add">Add Subject</Link> */}
                </div>
            </div>
            {
                showResults ?

                    <CustomTable
                        columns={columns}
                        data={data}
                    />
                    :
                    <DataLoader />
            }
        </div>
    )
}

export default AllSubjects;